import { Form, Input } from "antd";
import { Rule } from "antd/lib/form";
import { useShowInputContext } from "context/ShowInputContext";
import InvoiceLabelValue from "./InvoiceLabelValue";
import { CSSProperties } from "react";

export default function InvoiceTogglingInput({
  name,
  label,
  placeholder,
  initialValue,
  rules,
  className,
  inputType,
  style,
}: {
  name: string;
  label: string;
  placeholder?: string;
  initialValue: string | null;
  rules?: Rule[];
  className?: string;
  inputType?: string;
  style?: CSSProperties;
}) {
  const { showInput, isLoading } = useShowInputContext();

  return (
    <div>
      <InvoiceLabelValue
        label={label}
        initialValue={initialValue}
        className={className}
        showInput={showInput}
        style={style}
      />
      {showInput && (
        <Form.Item name={name} initialValue={initialValue} rules={rules}>
          <Input
            type={inputType}
            disabled={isLoading}
            placeholder={placeholder}
            style={style}
          />
        </Form.Item>
      )}
    </div>
  );
}
